import { Injectable } from '@angular/core';
import { BaseApi } from './base/base-api';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Project } from '../../../shared/models/project';
import { AggreatedLanguageTranslationState } from '../../../shared/models/dtc/aggreated-language-translation-state';
import { SKIP_SPINNER_CONTEXT_TOKEN } from './skip-spinner-context-token';
import { HttpContext } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProjectApiService extends BaseApi {
  constructor() {
    super(environment.api + 'project');
  }

  public getProjects(): Observable<Project[]> {
    return this.http.get<Project[]>(this.baseUrl);
  }

  public getByIdAsync(projectId: string, includeAlarmMaskCount = false): Observable<Project> {
    const queryPart = includeAlarmMaskCount ? '?includeAlarmMaskCount=True' : '';
    return this.http.get<Project>(this.baseUrl + '/' + projectId + queryPart);
  }

  public updateProject(project: Project): Observable<Project> {
    return this.http.put<Project>(this.baseUrl, project);
  }

  public getAggregatedTranslationStates(id: string): Observable<AggreatedLanguageTranslationState> {
    return this.http.get<AggreatedLanguageTranslationState>(this.baseUrl + '/aggregated-translation-states/' + id, {
      context: new HttpContext().set(SKIP_SPINNER_CONTEXT_TOKEN, true),
    });
  }
}
